import * as React from "react";
import PropTypes from "prop-types";
import "../DecisionMaker/DecisionMakerTable.css";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import decisionMakerImage from "../../Assets/Cloudfigma.svg";
import ContactDetailList from "../../Components/AiLeads/ContactDetailList/ContactDetailList";
import RightSidebar from "../RightSiderbar/RightSiderbar";
import axios from "axios";
import Loader from "../Loader/Loader";
import visitLinkImage from "../../Assets/visit-link.svg";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  APISalesforceUrl,
  APIDataUrl,
  APITokenUrl,
  APIGraphUrl,
  getConfidenceScore,
  GetOktaAuthData,
  GetUserId,
} from "../../Utils/Utils";
import IndustryDropdown from "../AiLeads/IndustrySectorDropdown/Index";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import starRed from "../../Assets/starRed.svg";
import startgray from "../../Assets/Stargrey.png";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ClearIcon } from "@mui/x-date-pickers";

import { useNavigate } from "react-router-dom";
import ProspectRequestModal from "../RequestUpdateModals/ProspectRequestModal";
import MessageModal from "../MessageModal/MessageModal";
import hoveridentifier from "../../Assets/hoverindentifier.svg";
import moment from "moment";
import sortingimg from "../../Assets/sortingarrow.svg";
import syncsorting from "../../Assets/syncsorting.svg";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import AddToFavoriteModal from "../FavoritesList/AddToFavoriteModal/AddToFavoritePeopleModal";
import AddToFavoritePeopleModal from "../FavoritesList/AddToFavoriteModal/AddToFavoritePeopleModal";
import SalesForceMessageModal from "../MessageModal/SalesForceMessageModal";
import activeSaleforceLogo from "../../Assets/activeSaleforceLogo.svg";
import { Avatar, Card, CardContent, Grid, Typography } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Padding } from "@mui/icons-material";
function Row({
  row,
  connectionStrength,
  setLoading,
  setRowsSelect,
  selectedOuterRows,
  favoritesList,
  handleRowSelect,
  listFavoriteRecords,
  tableCommingData,
  handlePassSubmit,
  
  
}) {
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [dataShortestPath, setDataShortestPath] = React.useState();
  const loggedInUserId = GetUserId();
  const [userDetails, setUserDeatils] = React.useState();
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleRightsidebar = (event) => {
    const data = {};
    data.source_uid = Number(loggedInUserId);
    data.target_uid = Number(event?.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIGraphUrl()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          const data = Object.values(response.data);
          setDataShortestPath(data);
          setOpenSidebar(true);
          setUserDeatils(event);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  // old api
  // const handleFavouriteLead = (row) => {
  //   setLoading(true)
  //   const data = {
  //     "user_id": Number(GetUserId()),
  //     "people_id": row.person_id
  //   }
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl()
  //     },
  //     data: data,
  //     url: `${APIDataUrl()}/v1/save_favourite_prospect`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false)
  //       listFavoriteRecords()
  //       toast.success("Prospect added to favorites")
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }

  // new add to fav api
  const handleFavouriteLead = (row) => {
    setLoading(true);
    // const data = {
    //   "people_id": row.person_id
    // }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: [row.person_id],
      url: `${APIDataUrl()}/favorites/people/list/add-record?user_id=${loggedInUserId}`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        handlePassSubmit();
        // listFavoriteRecords()
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // old add to fav api
  // const handleFavouriteLead = (row) => {
  //   setLoading(true)
  //   const data = {
  //     "user_id": Number(GetUserId()),
  //     "people_id": row.person_id
  //   }
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl()
  //     },
  //     data: data,
  //     url: `${APIDataUrl()}/v1/save_favourite_prospect`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false)
  //       listFavoriteRecords()
  //       toast.success("Prospect added to favorites")
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }

  // old api
  // const handleRemoveFavouriteLead = (row) => {
  //   const data = favoritesList?.find(item => item?.person_id == row?.person_id)
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl()
  //     },
  //     url: `${APIDataUrl()}/v1/remove_favourite_prospect?id=${data?.favourites_id}`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //       listFavoriteRecords()
  //       toast.success("Prospect removed from favorites")
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }
  const handleRemoveFavouriteLead = () => {
    const data = tableCommingData?.find(
      (item) => item?.person_id == row?.person_id,
    );
    const option = {
      method: "DELETE",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/favorites/delete_favorites_people?user_id=${loggedInUserId}`,
      data: [data.person_id],
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        listFavoriteRecords();
        handlePassSubmit();
        toast.success("Prospect removed from favorites");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <TableRow className="juyds" sx={{ "& > *": { borderBottom: "unset" } }}>
      <>
        <TableCell className="checkbox-row-table-inner checkbox-row-table">
          <div className="kjhgf">
            <input
              type="checkbox"
              onChange={() => handleRowSelect(row)}
              checked={selectedOuterRows.some(
                (item) => item.person_id === row?.person_id,
              )}
            />
          </div>
        </TableCell>
        {/* <TableCell
          component="th"
          scope="row"
        >
          <>

            {
              row?.isFavourite ? (
                <div className="kjhgf" onClick={() => handleRemoveFavouriteLead(row)}>
                  <img src={starRed} alt="Star Red" />
                </div>
              ) : (
                <div className="kjhgf" onClick={() => handleFavouriteLead(row)}>
                  <img src={startgray} alt="Star Gray" />
                </div>
              )
            }
          </>
        </TableCell> */}
        <TableCell className="Decisions-row-tableName-prospect" align="left">
          <div
            className={
              row?.decision_maker === true
                ? "Decision-maker-user-name"
                : "Decision-maker-user-noborder create-name-img"
            }
          >
            <img
              className={
                row?.suspect_status === null
                  ? "hide-image"
                  : row?.journey_status === "project created"
                    ? "decisionMakerImageAi-Decisionmaker-green"
                    : "decisionMakerImageAi-Decisionmaker"
              }
              // src={decisionMakerImage}
              src={
                row?.journey_status === "project created"
                  ? activeSaleforceLogo
                  : decisionMakerImage
              }
              alt=""
            />
            <p className="letter-heading">
              {row?.first_name
                ? row?.first_name
                    ?.split(" ")
                    ?.find((item) => !item.includes("("))
                    ?.charAt(0)
                : ""}
              {row?.last_name
                ? row?.last_name
                    ?.split(" ")
                    ?.find((item) => !item.includes("("))
                    ?.charAt(0)
                : ""}
            </p>
          </div>
        </TableCell>
        <TableCell
          className="Decision-maker-userTeblesell_row"
          align="left"
          onClick={() => {
            navigate(`/Profile/${row?.person_id == 0 ? "0" : row?.person_id}`);
          }}
          style={{ cursor: "pointer" }}
        >
          {" "}
          <div className="Decision-maker-user-name-main-container">
            <div className="name-and-title-text">
              <div className="fullnameofuser">
                <h3 className="company-name-country">
                  {row?.first_name === "jp" ? "JP" : row?.first_name || "---"}
                  &nbsp;
                  {row?.last_name ? row?.last_name : "---"}
                </h3>
              </div>

              <div className="job-title-container">
                <div className="tooltip-container-jobtitle">
                  <p
                    className={
                      row?.raw_job_title
                        ? "tooltip-highlights-jobtitle"
                        : "tooltip-highlights-jobtitle-none"
                    }
                  >
                    {row?.raw_job_title}
                  </p>
                  <p className="after-company-name-country-fordecisionmaker">
                    {row?.primary_job_title
                      ? row.primary_job_title.substring(0, 18) +
                        (row.primary_job_title.length > 18 ? "..." : "")
                      : "---"}
                  </p>
                </div>
              </div>

              {/* <p className="after-company-name-country-fordecisionmaker">
                {
                  row?.primary_job_title
                    ? row.primary_job_title.substring(0, 18) +
                    (row.primary_job_title.length > 18 ? "..." : "")
                    : "-"
                }
              </p> */}
            </div>
          </div>
        </TableCell>
        <TableCell component="th" scope="row">
          <p className="orbit-strength-control">
            {row?.strengthData?.strength ? row?.strengthData?.strength : "---"}
          </p>
        </TableCell>
        <TableCell align="left">
          <h3 className="annual-revenue-table">
            {row.primary_organization ? row.primary_organization : "---"}
          </h3>
        </TableCell>
        <TableCell
          align="left"
          className="table-cell-of-contact-details-dropdown-th"
        >
          <div
            className="Set-dropdown-ofIndustry"
            style={{ position: "relative" }}
          >
            <div className="email-andrelative-other-info">
              <div className="maked-component-of-dropdown-forai-leads">
                <IndustryDropdown row={row} />
              </div>
            </div>
          </div>
        </TableCell>
      <TableCell align="left">
        <div className="Suspect-table-data">
          <h3 className="industry-sector-table">
            {row?.suspect_status ? row.suspect_status : "---"}
          </h3>
        </div>
      </TableCell>
        <TableCell
          align="left"
          className="table-cell-of-contact-details-dropdown-th-prospect"
        >
          <div
            className="Set-dropdown-ofContactDetailList"
            style={{ position: "relative" }}
          >
            <div className="email-and-other-infodc">
              <div className="maked-component-of-dropdown">
                <ContactDetailList item={row} />
              </div>
            </div>
          </div>
        </TableCell>
      </>
      <TableCell className="table-cellhandleRightsidebar-prospect">
        <div
          className="table-cellhandleRightsidebar"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            className="button-collapse-table-propect"
          >
            <RightSidebar
              dataShortestPath={dataShortestPath}
              openSidebar={openSidebar}
              userDetails={userDetails}
              handleRightsidebar={handleRightsidebar}

              rowid={row}
            />
          </IconButton>
        </div>
      </TableCell>
    <TableCell>
      <td className="confience-score-icons">
        {" "}
        {/* Ensures proper positioning */}
        <div className="hover-container-prospects">
          <img
            src={hoveridentifier}
            alt=""
            className="hover-image-prospects"
          />

          <div
            className={`hover-content-prospects ${
              !row?.updated_at || !row?.confidence_score
                ? "no-update-prospects"
                : "has-update-prospects"
            }`}
          >
            <div className="data-sync-c-rate-prospects">
              <div className="datasync-line-c-score-prospects">
                <span className="datasync-line-prospects">Data Sync: </span>
                <span className="datasync-line-data-prospects">
                  {row?.updated_at
                    ? moment(row.updated_at).format("MM.DD.YY")
                    : "No update information available"}
                </span>
              </div>
              <div className="datasync-line-c-score-prospects">
                <span className="datasync-line-prospects">
                  Data Confidence Score:
                </span>
                <span className="datasync-line-data-prospects">
                  {row?.confidence_score
                    ? getConfidenceScore(row.confidence_score)
                    : "No update information available"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </td>
    </TableCell>
    </TableRow>
  );
}
Row.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  connectionStrength: PropTypes.string.isRequired,
};
export default function DecisionMakerTable({
  trackingData,
  tableCommingData,
  setTableCommingData,
  istableDataFilter,
  setCurrentLeadsLength,
  isDecisionMakerExcel,
  setIsDecisionMakerExcel,
  setIstableDataFilter,
  isSalesForceTrigger,
  setIsSalesForceTrigger,
  handlePassSubmit,
  firstFilterData,
  selectedProfile,
  setSkip,
  skip,
  setIsApplyFilter,
  applyFilter,
  archiveRecord,
  setArchiveRecord,
  trackRecord,
  setTrackRecord,
  setAddToFav,
  addToFav,
  requestUpdateRecord,
  setRequestUpdateRecord,
  setDisableRequestUpdate,
  setProfileRecords,
  profileRecords,
  selectedOuterRows,
  setSelectedOuterRows,
  DecisionMakerDataListing,
  setShowSalesForce,
  handleTrackingdata,
  setDisableTracking,
  
  
  sortOrder,
  sortField,
  handleSort,
  data,
  setData,
  
}) {
  const exportToExcel = (data, filename) => {
    const filteredData = data.map(
      ({ person_id, org_id, strengthData, ...rest }) => rest,
    );
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
  };

  const [loading, setLoading] = React.useState(false);
  const [decisionMakerData, setDecisionMakerData] = React.useState([]);
  const [checkDecisionMakerData, setcheckDecisionMakerData] = React.useState(
    [],
  );
  const loggedInUserId = GetUserId();

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [hasMore, setHasMore] = React.useState(false);
  const [isfetchData, setIsfetchData] = React.useState(false);
  const [totalPages, setTotalPages] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState("");
  const [rowsSelect, setRowsSelect] = React.useState({});
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [archivesList, setArchivesList] = React.useState([]);
  const [requestUpdateModal, setRequestUpdateModal] = React.useState(false);
  const [messageModal, setMessageModal] = React.useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);

  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const [successModel, setSuccessModel] = React.useState("");

  const perPage = 50;
  React.useEffect(() => {
    if (tableCommingData) {
      setDecisionMakerData(tableCommingData);
    }
  }, [tableCommingData]);

  const fetchDataReturnFilter = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "content-type": "plain/text",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/people?userid=${GetUserId()}&limit=50&skip=${
        skip ? skip * 50 : 0
      }`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        const comingData = response?.data?.data?.sort(
          (a, b) => (b.decision_maker ? 1 : 0) - (a.decision_maker ? 1 : 0),
        );
        //   const comingData = response?.data?.data?.sort((a, b) =>
        //     (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0) ||
        //     (b.decision_maker ? 1 : 0) - (a.decision_maker ? 1 : 0)
        // );

        if (comingData.length === 0) {
          setHasMore(false);
        } else {
          setDecisionMakerData(comingData);
          setTableCommingData(comingData);
          setIstableDataFilter(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getStrength = async () => {
    // if (!tableCommingData?.length) return;
    // setLoading(true);
    const tuples = tableCommingData.map((item) => ({
      items: [loggedInUserId?.toString(), item.person_id?.toString()],
    }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIGraphUrl()}/v1/conn_strength`,
    };
    try {
      const response = await axios(options);
      const strengthData = response?.data;
      const updatedData = tableCommingData?.map((item, index) => ({
        ...item,
        strengthData: strengthData[index],
      }));
      setDecisionMakerData(updatedData);
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };
  React.useEffect(() => {
    if (checkDecisionMakerData || tableCommingData) {
      getStrength();
    }
  }, [checkDecisionMakerData, tableCommingData]);
  React.useEffect(() => {
    if (profileRecords === true) {
      DecisionMakerDataListing();
    } else if (firstFilterData?.length && skip > 0) {
      handlePassSubmit();
    } else if (firstFilterData?.length === 0 && !applyFilter) {
      handlePassSubmit();
      // if (isfetchData) {
      //   // fetchData();
      // } else {
      //   setIsfetchData(true);
      // }
    }
  }, [
    skip,
    firstFilterData,
    applyFilter,
    isfetchData,
    profileRecords,
    selectedProfile,
  ]);
  React.useEffect(() => {
    // fetchData()
  }, []);
  React.useEffect(() => {
    if (istableDataFilter) {
      fetchDataReturnFilter();
    }
  }, [istableDataFilter]);
  React.useEffect(() => {
    if (decisionMakerData) {
      setCurrentLeadsLength(decisionMakerData?.length);
      // const favorite = decisionMakerData?.filter(item => item?.favourite_id !==null)?.map(item => item?.id)
      // setFavoritesList(favorite)
    }
  }, [decisionMakerData]);
  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to download");
        setIsDecisionMakerExcel(false);
        return;
      }
      exportToExcel(selectedOuterRows, "decisionmaker_exported_data");
    }
  }, [isDecisionMakerExcel]);

  const loadMore = () => {
    setLoading(true);
    setSkip((prev) => prev + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleRowSelect = (row) => {
    setSelectedOuterRows((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.person_id === row.person_id,
      );

      if (isAlreadySelected) {
        return prevSelectedRows.filter(
          (item) => item.person_id !== row.person_id,
        );
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  React.useEffect(() => {
    if (selectedOuterRows?.length < 1 && requestUpdateRecord == true) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select record to request update");
      return;
    } else if (selectedOuterRows?.length === 1 && requestUpdateRecord == true) {
      setRequestUpdateModal(true);
      setRequestUpdateRecord(false);
      setDisableRequestUpdate(false);
    } else if (selectedOuterRows?.length > 1 && requestUpdateRecord == true) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select only one record to request update");
    } else {
      setDisableRequestUpdate(false);
    }
  }, [selectedOuterRows, requestUpdateRecord]);

  const handleTrackRecords = (item) => {
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to track");
      setTrackRecord(false);
      return;
    } else {
      setLoading(true);
      const filteredData = selectedOuterRows.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.person_id) === Number(trackingItem.person_id),
          ),
      );

      if (filteredData.length === 0) {
        toast.error("All selected records are already tracked.");
        setLoading(false);
        return;
      }

      const data = filteredData.map((item) => item?.person_id);

      // const data = selectedOuterRows.map(item => item?.person_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APITokenUrl(),
        },
        data: data,
        url: `${APIDataUrl()}/v1/save_tracking_prospect?user_id=${Number(
          GetUserId(),
        )}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            setTrackRecord(false);
            toast.success("Tracking Added");
            setSelectedOuterRows([]);
            setMessageModalTrack(false);
            setDisableTracking(true);
            handleTrackingdata();
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };

  React.useEffect(() => {
    if (trackRecord == true) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to track");
        setTrackRecord(false);
        return;
      }
      setMessageModalTrack(true);
      setTrackRecord(false);

      // handleTrackRecords()
    }
  }, [trackRecord]);

  React.useEffect(() => {
    if (addToFav == true) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to Add To Favorites");
        setAddToFav(false);
        return;
      }
      setOpenCreateListmdl(true);
      setAddToFav(false);

      // handleTrackRecords()
    }
  }, [addToFav]);

  React.useEffect(() => {
    if (archiveRecord == true) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to archive");
        setArchiveRecord(false);
        return;
      }
      setMessageModal(true);
      setArchiveRecord(false);
    }
  }, [archiveRecord]);
  const listFavoriteRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/list_favourite_prospects?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      setFavoritesList(response?.data?.data);
      // setArchiveRecord(false)
      // toast.success("Prospects Archived Successfully")
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };
  const listArchiveRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/list_user_archive_prospects?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      const data = response?.data?.data?.filter(
        (item) => item?.org_id !== null,
      );
      setArchivesList(data);
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };
  React.useEffect(() => {
    listArchiveRecords();
    listFavoriteRecords();
  }, []);

  const handleRemoveFavouriteLead = (row) => {
    setLoading(true);
    const data = favoritesList?.find(
      (item) => item?.person_id == row?.person_id,
    );
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/remove_favourite_prospect?id=${
        data?.favourites_id
      }`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // const handleRemoveFavouriteLead = (row) => {
  //   setLoading(true)
  //   const data = favoritesList?.find(item => item?.person_id == row?.person_id)
  //   const option = {
  //     method: "DELETE",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl()
  //     },
  //     url: `${APIDataUrl()}/favorites/people/list/remove-record${data?.favourites_id}`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }

  const handleArchiveRecords = async () => {
    setLoading(true);
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to archive");
      setArchiveRecord(false);
      return;
    } else {
      await Promise.all(
        selectedOuterRows.map((i) => handleRemoveFavouriteLead(i)),
      );
      const data = selectedOuterRows.map((item) => ({
        user_id: Number(GetUserId()),
        people_id: item?.person_id,
      }));

      const options = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APITokenUrl(),
        },
        data: data,
        url: `${APIDataUrl()}/v1/send_archive`,
      };
      try {
        const response = await axios(options);
        setMessageModal(false);
        setArchiveRecord(false);
        setSelectedOuterRows([]);
        if (response?.data?.message === "Already archived") {
          toast.success("Prospects already Archived.");
        } else {
          listFavoriteRecords();
          toast.success("Prospects Archived Successfully");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      } finally {
      }
    }
  };

  // const handleArchiveRecords = async () => {
  //   if (!selectedOuterRows?.length) {
  //     toast.error("Please select records to archive")
  //     setArchiveRecord(false)
  //     return
  //   } else {
  //     const data = selectedOuterRows.map(item => ({
  //       user_id: Number(GetUserId()),
  //       // leads_id: null,
  //       people_id: item?.person_id
  //     }));

  //     const options = {
  //       method: "POST",
  //       headers: {
  //         "access-control-allow-origin": "*",
  //         "content-type": "application/json",
  //         "X-API-Key": APITokenUrl()
  //       },
  //       data: data,
  //       url: `${APIDataUrl()}/v1/send_archive`,
  //     };
  //     try {
  //       const response = await axios(options);
  //       setMessageModal(false)
  //       setArchiveRecord(false)
  //       if (response?.data?.message === "Already archived") {
  //         toast.success("Prospects already Archived.")

  //       } else {

  //         toast.success("Prospects Archived Successfully")
  //       }
  //       setSelectedOuterRows([])
  //       listArchiveRecords()
  //     } catch (error) {
  //       // setLoading(false);
  //       toast.error(error?.response?.data?.message);
  //     } finally {
  //       // setLoading(false);
  //     }
  //   }
  // }
  const validateSalesforce = () => {
    if (!selectedOuterRows || selectedOuterRows?.length === 0) {
      toast.error("Please Select Records For Push To Salesforce");
      return false;
    }
    return true;
  };
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      if (!validateSalesforce()) return;
      setMessageModalSalesforce(true);
      // pushToSalesForce();
    }
  }, [isSalesForceTrigger]);

  React.useEffect(() => {
    if (selectedOuterRows?.length) {
      const data = selectedOuterRows?.filter(
        (item) => item.suspect_status !== null,
      );
      if (data?.length) {
        setShowSalesForce("disable");
      } else {
        setShowSalesForce("show");
      }
    } else {
      setShowSalesForce(false);
    }
  }, [selectedOuterRows]);

  React.useEffect(() => {
    setData(decisionMakerData);
  }, [decisionMakerData]);

  const [arrowShow, setArrowShow] = React.useState();

  React.useEffect(() => {
    const sortedDataDefault = decisionMakerData
      ?.filter(
        (item) => !archivesList?.some((i) => i?.person_id === item?.person_id),
      )
      ?.sort((a, b) => {
        if (a.decision_maker && !b.decision_maker) return -1;
        if (!a.decision_maker && b.decision_maker) return 1;
        return (
          (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0)
        );
      });
    setData(sortedDataDefault);
  }, [decisionMakerData, archivesList]);
  const navigate = useNavigate();
  return (
    <>
      {loading ? <Loader /> : null}
      {decisionMakerData?.length ? (
        <>
          <TableContainer component={Paper} className="ai-leads-table-main">
            <Table
              aria-label="collapsible table"
              className="ai-leads-table"
            >
              <TableHead>
                <TableRow className="table-row-ai-leads">
                  <TableCell className="score-row-table">
                    {"Select"}
                  </TableCell>
                  {/* <TableCell className="score-row-table favorite_col_star">Favorite</TableCell> */}
                  <TableCell className="Decisions-row-tableName-prospect"></TableCell>
                  <TableCell className="Decisions-row-tableName">
                    <p className="prospect-Name-and-Title-prospect">
                      Name & Title {""}
                      {sortField === "first_name" ? (
                        sortOrder === "asc" ? (
                          <NorthIcon
                            className="up-down-arrows-sorting"
                            onClick={() => handleSort("first_name")}
                          />
                        ) : (
                          <SouthIcon
                            className="up-down-arrows-sorting"
                            onClick={() => handleSort("first_name")}
                          />
                        )
                      ) : (
                        <img
                          src={sortingimg}
                          alt=""
                          onClick={() => handleSort("first_name")}
                          className="sorting-arrow-leadsprofile"
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </p>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="DecisionstableStrengthnewclass"
                  >
                    <p className="DecisionstableStrength-strength">
                      Orbit Strength{""}
                      {sortField === "strengthData.strength" ? (
                        sortOrder === "asc" ? (
                          <NorthIcon
                            className="up-down-arrows-sorting"
                            onClick={() =>
                              handleSort("strengthData.strength")
                            }
                          />
                        ) : (
                          <SouthIcon
                            className="up-down-arrows-sorting"
                            onClick={() =>
                              handleSort("strengthData.strength")
                            }
                          />
                        )
                      ) : (
                        <img
                          src={sortingimg}
                          alt=""
                          onClick={() =>
                            handleSort("strengthData.strength")
                          }
                          className="sorting-arrow-leadsprofile"
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      {/* <img
                src={sortingimg}
                alt=""
                onClick={() => handleSort("strengthData.strength")}
                className="sorting-arrow-leadsprofile"
              /> */}
                    </p>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="employee-row-tableCompany"
                  >
                    <p className="DecisionstableStrength-companynew">
                      {" "}
                      Organization{" "}
                      {/* <img
                src={sortingimg}
                alt=""
                onClick={() => handleSort("primary_organization")}
                className="sorting-arrow-leadsprofile"
              /> */}
                      {sortField === "primary_organization" ? (
                        sortOrder === "asc" ? (
                          <NorthIcon
                            className="up-down-arrows-sorting"
                            onClick={() =>
                              handleSort("primary_organization")
                            }
                          />
                        ) : (
                          <SouthIcon
                            className="up-down-arrows-sorting"
                            onClick={() =>
                              handleSort("primary_organization")
                            }
                          />
                        )
                      ) : (
                        <img
                          src={sortingimg}
                          alt=""
                          onClick={() => handleSort("primary_organization")}
                          className="sorting-arrow-leadsprofile"
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </p>
                  </TableCell>
                  <TableCell
                    align="left"
                    className="annual-row-tableIndustry"
                  >
                    <p className="Industry-Sector-decision">
                      Industry/ Sector{" "}
                      {/* <img
                src={sortingimg}
                alt="Sort"
                onClick={() => handleSort("categories")}
              /> */}
                      {sortField === "categories" ? (
                        sortOrder === "asc" ? (
                          <NorthIcon
                            className="up-down-arrows-sorting"
                            onClick={() => handleSort("categories")}
                          />
                        ) : (
                          <SouthIcon
                            className="up-down-arrows-sorting"
                            onClick={() => handleSort("categories")}
                          />
                        )
                      ) : (
                        <img
                          src={sortingimg}
                          alt=""
                          onClick={() => handleSort("categories")}
                          className="sorting-arrow-leadsprofile"
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </p>
                  </TableCell>

                <TableCell
                  align="left"
                  className="industry-row-tableStatus"
                >
                  <p className="DecisionstableStrength-strength">
                    {" "}
                    Orbit Status{""}
                    {/* <img
          src={sortingimg}
          alt=""
          onClick={() => handleSort("suspect_status")}
          className="sorting-arrow-leadsprofile"
        /> */}
                    {sortField === "suspect_status" ? (
                      sortOrder === "asc" ? (
                        <NorthIcon
                          className="up-down-arrows-sorting"
                          onClick={() => handleSort("suspect_status")}
                        />
                      ) : (
                        <SouthIcon
                          className="up-down-arrows-sorting"
                          onClick={() => handleSort("suspect_status")}
                        />
                      )
                    ) : (
                      <img
                        src={sortingimg}
                        alt=""
                        onClick={() => handleSort("suspect_status")}
                        className="sorting-arrow-leadsprofile"
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </p>
                </TableCell>
                  <TableCell
                    align="left"
                    className="prospects-row-tableDetails-cd"
                  >
                    <p className="Com-details-prospect"> Contact Details</p>
                  </TableCell>
                  <TableCell
                    // align="left"
                    className="prospects-row-tableDetails-cd"
                  ></TableCell>
                <TableCell>
                  {sortField === "updated_at" ? (
                    sortOrder === "asc" ? (
                      <NorthIcon
                        className="sync-sorting-img-d-maker"
                        onClick={() => handleSort("updated_at")}
                      />
                    ) : (
                      <SouthIcon
                        className="sync-sorting-img-d-maker"
                        onClick={() => handleSort("updated_at")}
                      />
                    )
                  ) : (
                    <img
                      src={syncsorting}
                      alt=""
                      onClick={() => handleSort("updated_at")}
                      className="sync-sorting-img"
                    />
                  )}
                  {/* <img src={syncsorting} alt="" className="sync-sorting-img" /> */}
                </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((item, index) => (
                  <React.Fragment key={index}>
                    <Row
                      row={item} // Corrected: Use 'item' instead of 'row'
                      selected={selectedRows.includes(item.firstName)} // Ensure correct selection logic
                      onSelect={(firstName) => {
                        const selectedIndex =
                          selectedRows.indexOf(firstName);
                        let newSelected = [];

                        if (selectedIndex === -1) {
                          newSelected = newSelected.concat(
                            selectedRows,
                            firstName,
                          );
                        } else if (selectedIndex === 0) {
                          newSelected = selectedRows.slice(1);
                        } else if (
                          selectedIndex ===
                          selectedRows.length - 1
                        ) {
                          newSelected = selectedRows.slice(0, -1);
                        } else {
                          newSelected = selectedRows
                            .slice(0, selectedIndex)
                            .concat(selectedRows.slice(selectedIndex + 1));
                        }

                        setSelectedRows(newSelected);
                      }}
                      connectionStrength={item.connectionStrength}
                      setLoading={setLoading}
                      setRowsSelect={setRowsSelect}
                      selectedOuterRows={selectedOuterRows}
                      favoritesList={favoritesList}
                      setFavoritesList={setFavoritesList}
                      listFavoriteRecords={listFavoriteRecords}
                      handleRowSelect={handleRowSelect}
                      tableCommingData={tableCommingData}
                      handlePassSubmit={handlePassSubmit}

                    />
                  </React.Fragment>
                ))}

                {/* {data?.filter(item => !archivesList?.some(i => i?.person_id === item?.person_id))?.map((row, index) => (
          <React.Fragment key={index}>
            <Row
              row={row}
              selected={selectedRows.includes(row)}
              onSelect={(firstName) => {
                const selectedIndex = selectedRows.indexOf(firstName);
                let newSelected = [];
                if (selectedIndex === -1) {
                  newSelected = newSelected.concat(
                    selectedRows,
                    firstName
                  );
                } else if (selectedIndex === 0) {
                  newSelected = newSelected.concat(
                    selectedRows.slice(1)
                  );
                } else if (selectedIndex === selectedRows.length - 1) {
                  newSelected = newSelected.concat(
                    selectedRows.slice(0, -1)
                  );
                } else if (selectedIndex > 0) {
                  newSelected = newSelected.concat(
                    selectedRows.slice(0, selectedIndex),
                    selectedRows.slice(selectedIndex + 1)
                  );
                }
                setSelectedRows(newSelected);
              }}
              connectionStrength={row.connectionStrength}
              setLoading={setLoading}
              setRowsSelect={setRowsSelect}
              selectedOuterRows={selectedOuterRows}
              favoritesList={favoritesList}
              setFavoritesList={setFavoritesList}
              listFavoriteRecords={listFavoriteRecords}
              handleRowSelect={handleRowSelect}
            />
          </React.Fragment>
        ))} */}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="loadmore-pagination-section">
            {totalCount !== decisionMakerData?.length && (
              <button
                className="btn-load-more button-loadmore-pagination"
                onClick={loadMore}
                disabled={loading}
              >
                {loading ? "Loading..." : "Load More"}
              </button>
            )}
          </div>
        </>
      ) : (
        <div className="ai-leads-table-main">
          <div className="ai-leads-no-data-available-outter">
            <div className="ai-leads-no-data-available">
              No Data Available
            </div>
          </div>
        </div>
      )}

      {/* </InfiniteScroll> */}
      <MessageModal
        open={messageModal}
        setOpen={setMessageModal}
        message={`Are you sure that you want to archive ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        }?`}
        handleSubmit={handleArchiveRecords}
        // favoritesList={favoritesList}
        // listFavoriteRecords={listFavoriteRecords}
        length={selectedOuterRows?.length}
      />
      <MessageModal
        open={messageModalTrack}
        setOpen={setMessageModalTrack}
        message={`Are you sure that you want to add ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        } to tracking?`}
        handleSubmit={handleTrackRecords}
        length={selectedOuterRows?.length}
      />
      {/* <MessageModal open={messageModalSalesforce} setOpen={setMessageModalSalesforce} message={`Are you sure that you want to push ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to Salesforce?`} handleSubmit={pushToSalesForce} length={selectedOuterRows?.length} /> */}
      <SalesForceMessageModal
        open={messageModalSalesforce}
        setOpen={setMessageModalSalesforce}
        selectedOuterRows={selectedOuterRows}
        setSelectedOuterRows={setSelectedOuterRows}
        setIsSalesForceTrigger={setIsSalesForceTrigger}
        decisionMakerData={decisionMakerData}
        setLoading={setLoading}
      />
      <ProspectRequestModal
        requestUpdateRecord={requestUpdateModal}
        setRequestUpdateRecord={setRequestUpdateModal}
        profileData={selectedOuterRows[0]}
        peopleId={selectedOuterRows?.[0]?.person_id}
        setSelectedOuterRows={setSelectedOuterRows}
        setSuccessModel={setSuccessModel}
        successModel={successModel}
      />

      <AddToFavoritePeopleModal
        open={openCreateListmdl}
        setOpen={setOpenCreateListmdl}
        selectedOuterRows={selectedOuterRows}
        message={`Are you sure that you want to add ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        } to Favorites?`}
        handlePassSubmit={handlePassSubmit}
        setSelectedOuterRows={setSelectedOuterRows}
      />
      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon onClick={() => setSuccessModel(false)} />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                Orbit Team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>
    </>
  );
}
DecisionMakerTable.propTypes = {};
Row.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  connectionStrength: PropTypes.string.isRequired,
};
